

export const getLocalMoniteringLog = async ({
    isMaskedLogVisible = true,
}) => {
    try {
        const hostname = window.location.hostname;
        const response = await fetch(`http://${hostname}:3001/api/listLogs?mask=${isMaskedLogVisible}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        // console.log("fetch result", data);
        return data;
    } catch (error) {
        console.log("fetch error",error);
        return [];
    }
}
